import AlertIcon from "_+_Portal/assets/images/generico/AlertIcon";
import { ContainerSinRed } from "./localStyle";

const SinRed = () => {
    return (
        <ContainerSinRed>
             <img
          style={{ marginBottom: 25, width: 126, height: 52 }}
          src="../../../../assets/images/empresa/IsoLogo.png"
          alt="logo"
          className="logo"
        ></img>
            <AlertIcon width={145} height={145} color={"var(--color-latex10)"}/>
           <h1>No tenés conexión a internet</h1>
           <span>Asegurate de tener los datos  móviles activados o contar con conexión WiFi y volvé a intentarlo</span>
            <button onClick={() => window.location.reload()}>Reintentar</button>
        </ContainerSinRed>
     );
}
 
export default SinRed;